import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class BankAccountTransactionSettlementRuleForm extends CerFormAdapter {

  public override view(): CerFormView {

    return new CerFormView({
      viewMetadata: {
        name: 'afstemningsregler', dataApiName: 'BankAccountSettlementRule', text: 'Regler', textSingular: 'Regel',
        primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history']
      },
      fieldMetadata:
        [
          { name: 'active', text: 'Aktiv', format: 'CheckBox', defaultValue: true },
          { name: 'priority', text: 'Prioritet', format: 'Integer', defaultValue: 10, orderBy: 'Ascending' },
          { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyColumns: ['name', 'bankIban'], foreignKeyTitles: ['Navn', 'IBAN'] },
          { name: 'bankTransType', text: 'Match transaktions type' },
          { name: 'bankAuthReferenceRequired', text: 'Match reference (bank)', format: 'CheckBox' },
          { name: 'voucherAuthReferenceRequired', text: 'Match reference (bilag)', format: 'CheckBox' },
          { name: 'userMatchRequired', text: 'Match godkender/kort', format: 'CheckBox' },
          { name: 'maxAmtCurDiffNegative', text: 'Beløb-', format: 'Amount' },
          { name: 'maxAmtCurDiffPositive', text: 'Beløb+', format: 'Amount' },
          { name: 'maxAmtPctDiffNegative', text: 'Beløb- %', format: 'IntegerPct' },
          { name: 'maxAmtPctDiffPositive', text: 'Beløb+ %', format: 'IntegerPct' },
          { name: 'maxDaysDiffNegative', text: 'Dage-', format: 'Integer' },
          { name: 'maxDaysDiffPositive', text: 'Dage+', format: 'Integer' },
          { name: 'ledgerAccountDiff', text: 'Difference finanskonto', foreignKeyTableName: 'FinanceLedgerAccount', foreignKeyField: 'num', foreignKeyValue: 'numName', foreignKeyColumns: ['num', 'name'], foreignKeyTitles: ['Konto', 'Navn'] }
        ],
      fieldGroupMetadata: [
        { idx: 1, tabIdx: 0, name: 'identification', text: 'Identifikation', fields: ['id', 'name'] },
        { idx: 2, tabIdx: 0, name: 'setup', text: 'Opsætning', fields: ['active', 'priority'] },
        { idx: 3, tabIdx: 0, name: 'match', text: 'Krav til match', fields: ['bankAccount', 'bankTransType', 'bankAuthReferenceRequired', 'voucherAuthReferenceRequired', 'userMatchRequired'] },
        { idx: 5, tabIdx: 0, name: 'maxDiffNegative', text: 'Match negativ tolerance', fields: ['maxAmtCurDiffNegative', 'maxAmtPctDiffNegative', 'maxDaysDiffNegative'] },
        { idx: 4, tabIdx: 0, name: 'maxDiffPositive', text: 'Match positiv tolerance', fields: ['maxAmtCurDiffPositive', 'maxAmtPctDiffPositive', 'maxDaysDiffPositive'] },
        { idx: 6, tabIdx: 0, name: 'diffPosting', text: 'Bogfør difference', fields: ['ledgerAccountDiff'] }
      ]
    });
  }
}
